import theme from '@theme-ui/preset-tailwind';

export const grids = {
  ...(theme.grids && theme.grids),
};
